module.exports = __webpack_public_path__ + "static/media/school_3.95110c77.JPG";